module.exports = __webpack_public_path__ + "img/bo.4128202a.svg";